import React from 'react';

import { getTestId } from '@utils';
import { useNavigate } from '@utils/hooks';

import { useStore } from '@modules';
import { ProtectNextEnum } from '@modules/types';

import InfoModal from '@containers/InfoModal';

import Illustration from './Illustration';
import { useCustomContext } from '../context';

const ti = getTestId('Intro');

const { setupOTP } = ProtectNextEnum;

const Intro: CustomFC = () => {
  const { t, startKYC, onBack } = useCustomContext();
  const navigate = useNavigate();
  const [{ login }] = useStore();

  const handleSkip = () => {
    if (login.protectNext === setupOTP) {
      navigate(CONST.nav.intro2fa);
    } else {
      onBack();
    }
  };

  const handleSubmit = () => {
    startKYC();
  };

  return (
    <InfoModal
      title={t('kyc_intro.h1')}
      description={t('kyc_intro.description')}
      buttonText={t('kyc_intro.button')}
      linkText={t('kyc_intro.skip')}
      onClickButton={handleSubmit}
      onClickLink={handleSkip}
      backButton={onBack}
      testId={ti()}
    >
      <Illustration />
    </InfoModal>
  );
};

export default Intro;
